import {computed, ComputedRef, ref} from 'vue';
import {FormValidator, IFormDefinition} from '@common/core';
import {ProblemDetailsType} from '@common/types';

export interface IValidatedForm {
  cleanErrors(): void;

  isValid(): Promise<boolean>;

  onCleanErrors(e: { formId: string }): void;

  onSetProblemDetails(e: { formId: string, problemDetails: ProblemDetailsType }): void;

  onValidateForm(e: { formId: string, cb: { (p: Promise<void>): void } }): void;

  setProblemDetails(e: ProblemDetailsType): void;

  validateField(fieldName: string): void;

  validateForm(): Promise<void>;

  validator: ComputedRef<FormValidator>;
}

export const useValidatedForm = (props: {
  definition?: IFormDefinition,
  data?: any,
  formId?: string
}): IValidatedForm => {
  // Variables
  const validated = ref(false);

  // Computed
  const validator = computed(() => {
    if (props.definition && props.data)
      return new FormValidator(props.definition, props.data);

    return new FormValidator({}, {});
  });

  // Methods
  const cleanErrors = () => {
    validator.value.cleanErrors();
  };

  const isValid = () => {
    validated.value = true;

    return validator.value.isValid();
  };

  const setProblemDetails = (e: ProblemDetailsType) => {
    validated.value = true;

    validator.value.setProblemDetails(e);
  };

  const validateField = (fieldName: string) => {
    if (!validated.value) {
      return;
    }

    validator.value.validateField(fieldName);
  };

  const validateForm = () => {
    validated.value = true;

    return validator.value.validateForm();
  };

  const onCleanErrors = (e: { formId: string }) => {
    if (props.formId === e.formId) {
      cleanErrors();
    }
  };

  const onSetProblemDetails = (e: { formId: string, problemDetails: ProblemDetailsType }) => {
    if (props.formId === e.formId) {
      setProblemDetails(e.problemDetails);
    }
  };

  const onValidateForm = (e: { formId: string, cb: { (p: Promise<void>): void } }) => {
    if (props.formId === e.formId) {
      e.cb(validateForm());
    }
  };

  return {
    cleanErrors,
    isValid,
    onCleanErrors,
    onSetProblemDetails,
    onValidateForm,
    setProblemDetails,
    validateField,
    validateForm,
    validator,
  };
};